import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';
import { DataSourceResponse, Diagnose, DiagnoseNodeItem } from "../../models";

@Injectable()
export class DiagnoseService extends ApiService {
    endPoint = '/api/diagnoses';
    create(model: Diagnose) {
        return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
    }

    update(id: string, model: Diagnose) {
        return this.http.put(`${this.commonBaseURL}${this.endPoint}/${id}`, model);
    }

    delete(id: string) {
        return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
    }
    deleteRange(ids: string[]) {
        return this.http.post<any>(`${this.commonBaseURL}${this.endPoint}/deleteRange`, ids);
    }
    get(id: string): Observable<Diagnose> {
        return this.http.get<Diagnose>(`${this.commonBaseURL}${this.endPoint}/${id}`);
    }

    getDiagnoses(queryParams?: any): Observable<DataSourceResponse<Diagnose>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
    }

    getChildren(parentId: string): Observable<DiagnoseNodeItem[]> {
        return this.http.get<DiagnoseNodeItem[]>(`${this.commonBaseURL}${this.endPoint}/${parentId}/diagnoses`);
    }

    search(searchText: string, onlySelectable = false, limit = 10): Observable<DiagnoseNodeItem[]> {
        const params = new HttpParams()
            .set('searchText', searchText)
            .set('limit', limit)
            .set('onlySelectable', onlySelectable);
        return this.http.get<DiagnoseNodeItem[]>(`${this.commonBaseURL}${this.endPoint}/search`, { params });
    }
    getByIds(ids: string[]): Observable<DiagnoseNodeItem[]> {

        return this.http.post<DiagnoseNodeItem[]>(`${this.commonBaseURL}${this.endPoint}/getByIds`, ids);
    }
}
